<!-- CDkey -->
<template>
  <div class="container">
    <div class="main">
      <div class="exchange">
        <input v-model="cdkey" type="text" class="cdkey" placeholder="请输入您的兑换码">
        <button class="exbtn" @click="btnThrottle">兑换</button>
      </div>
      <div class="text">
        <p class="introduce">
          兑换码是什么：
          <br>兑换码是“口袋故事”应用内的一种VIP抵用券
        </p>
        <p class="introduce">
          兑换码使用方法：
          <br>输入获取的兑换码后点击【兑换】即可；
          <br>兑换成功后请下载口袋故事APP，使用同一个账号登录即可。
        </p>
        <p class="introduce">如使用遇到问题，可添加工作人员微信koudai020获取帮助。</p>
      </div>
      <div class="footer">
        <GoDownloadRect :url="appStoreUrl"></GoDownloadRect>
      </div>
    </div>
  </div>
</template>

<script>
import GoDownloadRect from '@/components/GoDownloadRect/index'

import { login } from '@/utils/login'
import { sendCdkey } from '@/api/cdkey'
import { throttle, setSafairHeight } from '@/utils/util'
import Cookies from 'js-cookie'
import browserCheck from '@/utils/checkBrowser'
export default {
  components: { GoDownloadRect },
  data() {
    return {
      appStoreUrl:
        'https://a.app.qq.com/o/simple.jsp?pkgname=com.appshare.android.ilisten&ckey=CK1321531259444',
      cdkey: '',
      btnThrottle: () => {}
    }
  },
  created() {
    this.getLocalCdkey()
    this.btnThrottle = throttle(this.goExchang, 1000)

  },
  methods: {
    async goExchang() {
      // check login
      if (!this.$store.getters.token) {
        return login(window.location.href)
      }

      // check input
      if (this.isEmpty()) {
        try {
          // send
          let res = await sendCdkey(this.$store.getters.token, this.cdkey)
          this.$toast.show({
            text: '兑换成功'
          })
        } catch (e) {
          if (e.msg === '不存在该兑换码') {
            this.$toast.show({
              text: '不存在该兑换码'
            })
          } else if(e.msg === '该兑换码已无效') {
            this.$toast.show({
              text: '该兑换码已无效'
            })
          } else {
            this.$toast.show({
              text: '兑换失败'
            })
          }
        }
      } else {
        this.$toast.show({
          text: '请输入兑换码'
        })
      }
    },
    isEmpty() {
      return this.cdkey.length == 0 ? false : true
    },
    getLocalCdkey() {
      this.cdkey = Cookies.get('ilistenh5.cdkey') || ''
    }
  },
  computed: {},
  mounted() {
    setSafairHeight(['.container', '.main'])
  },
  watch: {
    cdkey(newKey, oldKey) {
      Cookies.set('ilistenh5.cdkey', newKey, { expires: 1 / 24 / 6 })
    }
  }
}
</script>

<style scoped lang="less">
@import "~@/styles/fn";
.cdkey::-webkit-input-placeholder {
  color: #c4c4c6;
}
.cdkey:-moz-placeholder {
  color: #c4c4c6;
}
.cdkey:-ms-input-placeholder {
  color: #c4c4c6;
}

.container {
  background: #f4f4f8;
}
.main {
  width: 100%;
  margin: 0 auto;
  min-height: 100vh;
}
.exchange {
  position: relative;
  width: 100%;
  height: 4rem;
  text-align: center;
  padding-top: 0.64rem;
  box-sizing: border-box;
  background-color: #fff;
}
.text {
  padding: 0.14rem 0.4rem;
}
.cdkey {
  width: 6.54rem;
  height: 0.96rem;
  padding: 0.28rem 0.24rem;
  background: #f4f4f8;
  border-radius: 0.06rem;
  margin: 0 auto;
  border: none;
  font-size: 0.28rem;
  color: #c4c4c6;
  box-sizing: border-box;
  outline: none;
}
.exbtn {
  margin: 0 auto;
  display: block;
  width: 4.8rem;
  height: 1.12rem;
  background: #fedc42;
  border-radius: 0.58rem;
  border: none;
  margin-top: 0.64rem;
  font-size: 0.34rem;
  color: #604038;
  text-align: center;
  font-weight: 700;
  outline: none;
}
.introduce {
  font-size: 0.28rem;
  color: #a0a0a6;
  padding: 0.1rem 0;
  width: 100%;
  box-sizing: border-box;
}
.footer {
  width: 100%;
  position: fixed;
  bottom: 0;
}
</style>
